/**
 * @param   {object}   state
 *
 * @returns {Function}
 */
const getUser = state => () => state.user

/**
 * @param   {object}   state
 *
 * @returns {object[]}
 */
const getGroups = state =>
  state.permissions
    .map(permission => permission.group)
    .sort((group1, group2) => {
      const group1Name = group1.display_name || group1.name
      const group2Name = group2.display_name || group2.name

      return group1Name.localeCompare(group2Name)
    })

/**
 * @param   {object}   state
 *
 * @returns {Function}
 */
const getSelectedGroupId = state => () =>
  state.selectedGroupId ? Number.parseInt(state.selectedGroupId) : null

/**
 * @param   {object}   state
 * @param   {number}   groupId
 *
 * @returns {Function}
 */
const getGroupById = state => groupId => {
  const division = state.permissions.find(
    permission => permission.group.id === groupId
  )

  return division ? division.group : null
}

/**
 * @param   {object}   state
 *
 * @returns {Function}
 */
const getSeasons = state => () => state.seasons

/**
 * @param   {object}   state
 *
 * @returns {Function}
 */
const getSelectedSeasonId = state => () =>
  state.selectedSeasonId ? Number.parseInt(state.selectedSeasonId) : null

/**
 * @param   {object}   state
 * @param   {number}   seasonId
 *
 * @returns {Function}
 */
const getSeasonById = state => seasonId =>
  state.seasons.find(season => season.id === seasonId)

/**
 * @param   {object}   state
 *
 * @returns {Function}
 */
const getInvites = state => () => state.invites

/**
 * @type {object}
 */
const getters = {
  getUser,
  getGroups,
  getSelectedGroupId,
  getGroupById,
  getSeasons,
  getSelectedSeasonId,
  getSeasonById,
  getInvites
}

export default getters
